/* eslint-disable jsx-a11y/alt-text */
// JavaScript source code
import './styles/HomePage.css';
import { useSearchParams } from "react-router-dom";
import { useState, useRef, useEffect } from 'react';
import GameImageHeader from './GameImageHeader';
import NewsletterSignUp from './NewsletterSignUp';
import PopupMessageContainer from './PopupAlerts/PopupMessageContainer.js';
import Cookies from 'js-cookie';
import webContentStrings from "./ContentStrings/LocalizedStrings.js";
import { IsMobile, GetGame, IsValid } from './Utilities.js';
import GameCard from './components/library/Game.js'
import Popup from './components/library/Popup.js';

function UXHomePage() {
    const [queryParams] = useSearchParams();
    const [seenPopup, setSeenPopup] = useState(Cookies.get("SeenPopup") === 'true');
    const [mobile, setMobile] = useState(IsMobile());
    const [gameArray, setGameArray] = useState([]);
    const gameInfoList = useRef({});
    const [gameInfoState, setGameInfoState] = useState(gameInfoList.current);
    const [currIndex, setCurrIndex] = useState(0);
    const [showPopup, setShowPopup] = useState(false);

    function onGetStartedClick() {
        window.location.assign("/login?page=signUp")
    }

    useEffect(() => {
        const handleResize = () => {
            setMobile(IsMobile());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const signUpReqOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + '/GetFrontPageGames', signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    setGameArray(JSON.parse(data.message));
                }
            });
    }, []);

    useEffect(() => {
        const signUpReqOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(process.env.REACT_APP_NODE_ADDRESS + "/GetHomePageHeaderGames", signUpReqOptions)
            .then((res) => res.json())
            .then((data) => {
                if (data.success === true) {
                    var gamesArray = JSON.parse(data.message);

                    gamesArray.map((ID) => {
                        GetGame(ID).then((gameInfo) => {
                            if (IsValid(gameInfo) !== true) return;

                            if (gameInfo.success === true) {
                                gameInfoList.current[ID] = gameInfo.message;
                            }


                            if (Object.entries(gameInfoList.current).length === 5) {
                                setTimeout(100);
                                setGameInfoState({ ...gameInfoList.current });
                            }
                        });
                        return;
                    });
                }
            });
    }, []);

    function testClick() {
        console.log("Clicked");
    }

    const handleClick = () => {
        setShowPopup(!showPopup);
    }

    return (
        <div className="homePage">
            {seenPopup !== true && <PopupMessageContainer />}
            {showPopup === true && <Popup handleClick={handleClick} gameId={currIndex} />}
            <div className={mobile ? "mobileTitleLine" : "titleLine"}>
                <GameImageHeader gameHeaderDic={gameInfoState} newCurrIndex={setCurrIndex} />
                <div className={mobile ? "mobileTopBody" : "topBody"}>
                    <div className={mobile ? "mobileInfo" : "info"}>
                        {IsValid(gameInfoState[currIndex]) === true && IsValid(gameInfoState[currIndex].LogoUrl) === true && <img className="gameTitleLogo" src={gameInfoState[currIndex].LogoUrl}></img>}
                        <h1 className={mobile === true ? "titleMobile" : "title"}>{IsValid(gameInfoState[currIndex]) === true ? gameInfoState[currIndex].Name : ""}</h1> <br />
                        <div className="gameLinksBreak">
                            <hr />
                            {IsValid(gameInfoState[currIndex]) === true && IsValid(gameInfoState[currIndex].SteamLink) === true && <img src="SteamButton.png" role="button" onClick={() => window.location.assign(gameInfoState[currIndex].SteamLink) } />}
                            <img src="DownloadButton.png" onClick={() => window.location.assign("/GameDownloads" + (IsValid(gameInfoState[currIndex]) === true ? '#' + gameInfoState[currIndex].ID : ""))} />
                            <hr />
                        </div>
                        <h2 className="tagline">{IsValid(gameInfoState[currIndex]) === true ? gameInfoState[currIndex].Tagline : ""}</h2>
                        <p className="subTagLine">{IsValid(gameInfoState[currIndex]) === true ? gameInfoState[currIndex].Description : ""}</p>
                        <div className="ludareLogoBreak">
                            <hr />
                            <img src="IconBlackNoBackground.png" />
                            <hr />
                        </div>
                        <div className={mobile === true ? "learnMoreButtonsMobile" : "learnMoreButtons"}>
                            {IsValid(gameInfoState[currIndex]) === true && IsValid(gameInfoState[currIndex].TrailerUrl) === true && <button className="startButton" onClick={() => window.open(gameInfoState[currIndex].TrailerUrl, "_blank", "noopener,noreferrer")}>{webContentStrings.homePageStrings.trailer}</button>}
                            <button className="startButton" onClick={() => setShowPopup(!showPopup)}>{webContentStrings.homePageStrings.learnMore}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="companyDesc">
                <p className="descTitle">{webContentStrings.homePageStrings.descTitle1}<span style={{ color: "#f9b422"}} >{webContentStrings.homePageStrings.descTitle2}</span></p>
                <p className="descDesc">{webContentStrings.homePageStrings.descText}</p>
                <div className="homePageButtonsContainer">
                    <button className="homePageInfoButtons" onClick={() => { window.location.assign("/account") }} >{webContentStrings.homePageStrings.startButtonText}</button>
                    <img className="companyLogoDescImage" src="/IconBlackYellowWingsNoBackground.png" alt="Ludare Logo" />
                    <button className="homePageInfoButtons" onClick={() => { window.location.assign("/login?page=signUp") }} >{webContentStrings.homePageStrings.signUp}</button>
                </div>
            </div>

            <div className="gamePreviewContainer">
                <div className={mobile ? "mobileGamePreviewHeader" : "gamePreviewHeader"}>
                    <p className="gamePreviewHeaderTitle">{webContentStrings.homePageStrings.gamePreviewTitle1} <span style={{ color: "#FFCF00" }}>{webContentStrings.homePageStrings.gamePreviewTitle2}</span></p>
                    <div className="gamePreviewHeaderButtons">
                        <button className="previewLibraryButton" onClick={() => window.location.assign("/Library") }>{webContentStrings.homePageStrings.gamePreviewLibrary}</button>
                        <button className="previewSubButton" onClick={() => window.location.assign("/account/subscription")}>{webContentStrings.homePageStrings.gamePreviewSub}</button>
                    </div>
                </div>
                <div className="previewGameContainer">
                    {gameArray.map((game, index) => {
                        return (<GameCard gameId={game} />);
                    })}
                </div>
            </div>

            <div className="roleSelection">
                <h1 className="roleQuestion">{webContentStrings.homePageStrings.roleTitle1}<span style={{ color: "#f9b422" }}>{webContentStrings.homePageStrings.roleTitle2}</span></h1>
                <div className="roleTiles">
                    <div className="playerTile" onClick={() => {window.location.assign("/players") } }>
                        <div className="playerTileTitle">
                            <img className="playerTileImage" src="/Icon_Renders/WithDepthBlur/Ludare_IconRender_WDP_Controller_01.png" alt="Gamepad Icon" />
                            <p className="playerTileTitleText">{webContentStrings.homePageStrings.playerRoleTitle}</p>
                        </div>
                        <p className="playerTileText">{webContentStrings.homePageStrings.playerRoleDesc}</p>
                        
                    </div>
                    <div className="developerTile" onClick={() => { window.location.assign("/studios") }}>
                        <div className="developerTileTitle">
                            <img className="developerTileImage" src="/Icon_Renders/WithDepthBlur/Ludare_IconRender_WDP_Dev_01.png" alt="Game Developer Icon" />
                            <p className="developerTileTitleText">{webContentStrings.homePageStrings.devRoleTitle}</p>
                        </div>
                        <p className="developerTileText">{webContentStrings.homePageStrings.devRoleDesc}</p>
                        
                    </div>
                </div>
            </div>
            <div className="newsletterSignUp">
                <NewsletterSignUp />
            </div>
        </div>
    );
}

//<a className="playerTileSelect" href="/players">{webContentStrings.homePageStrings.playerRoleSelect}</a>
//<a className="developerTileSelect" href="/studios">{webContentStrings.homePageStrings.devRoleSelect}</a>
/*            */

export default UXHomePage;